import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const ButtonsLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  // visualizzazione orizzontale solo con gli omissis
  &.horizontal {
    flex-direction: row;
    gap: 24px;

    > div {
      width: 50%;
    }
  }
`;

export interface IButtonsLayoutProps {
  children?: React.ReactNode;
  horizontal?: boolean;
  hasOmissis?: boolean;
}

export function ButtonsLayout(props: IButtonsLayoutProps) {
  const { children, horizontal, hasOmissis } = props;

  return (
    <ButtonsLayoutWrapper
      className={clx({ horizontal: horizontal && hasOmissis })}
    >
      {children}
    </ButtonsLayoutWrapper>
  );
}
